  <template>
    <div
      class="page-wrapper"
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin6"
      data-sidebartype="full"
      data-sidebar-position="fixed"
      data-header-position="static"
    >
      <!-- SIDEBAR -->
      <aside class="left-sidebar" ref="sidebar">
        <div class="sidebar-content">
          <div
            class="brand-logo d-flex align-items-center justify-content-between text-center mt-5 mb-3"
          >
              <router-link to="/app" class="text-nowrap logo-img mx-auto tour-logo">
              <img
                src="/assets/images/logos/logotipo-bg-branco.svg"
                width="200"
                alt="WiseCalc"
              />
            </router-link>

            <div
              class="close-btn d-xl-none d-block cursor-pointer"
              @click="fecharSidebar"
            >
              <i class="ti ti-x fs-8 ms-5"></i>
            </div>
          </div>

          <nav class="sidebar-nav scroll-sidebar">

            <ul
              id="sidebarnav-admin"
              v-if="isAdmin"
            >

              <li class="nav-small-cap mt-3">
                <span class="hide-menu">ADMIN</span>
              </li>

              <li class="sidebar-item">
                <router-link
                  to="/app/admin"
                  class="sidebar-link tour-dashboard"
                  active-class="active"
                  @click="fecharSidebar"
                >
                  <i class="ti ti-layout-dashboard"></i>
                  <span class="hide-menu">Admin</span>
                </router-link>
              </li>

            </ul>

            <!-- INÍCIO -->
            <ul class="sidebarnav tour-inicio-projetos">
              <li class="nav-small-cap tour-inicio-label">
                <span class="hide-menu">INÍCIO</span>
              </li>
              <li class="sidebar-item">
                <router-link
                  to="/app"
                  class="sidebar-link tour-projetos"
                  :class="{ active: $route.path === '/app' }"
                  @click="fecharSidebar"
                >
                  <i class="ti ti-folder"></i>
                  <span class="hide-menu">Projetos</span>
                </router-link>
              </li>
            </ul>

            <!-- MINHA CONTA -->
            <ul class="sidebarnav tour-conta">
              <li class="nav-small-cap">
                <span class="hide-menu">MINHA CONTA</span>
              </li>
              <li class="sidebar-item">
                <router-link
                  to="/app/edit-user"
                  class="sidebar-link"
                  active-class="active"
                  @click="fecharSidebar"
                >
                  <i class="ti ti-user"></i>
                  <span class="hide-menu">Editar perfil</span>
                </router-link>
              </li>
              <li class="sidebar-item">
                <router-link
                  to="/app/change-password"
                  class="sidebar-link"
                  active-class="active"
                  @click="fecharSidebar"
                >
                  <i class="ti ti-lock"></i>
                  <span class="hide-menu">Alterar senha</span>
                </router-link>
              </li>
            </ul>

            <!-- WISECALC PRO -->
            <ul class="sidebarnav tour-assinatura">
              <li class="nav-small-cap">
                <span class="hide-menu">WISECALC PRO</span>
              </li>
              <li class="sidebar-item">
                <router-link
                  to="/app/my-plan"
                  class="sidebar-link"
                  active-class="active"
                  @click="fecharSidebar"
                >
                  <i class="ti ti-credit-card"></i>
                  <span class="hide-menu">Minha assinatura</span>
                </router-link>
              </li>
            </ul>

            <!-- SUPORTE -->
            <ul class="sidebarnav tour-suporte">
              <li class="nav-small-cap">
                <span class="hide-menu">SUPORTE</span>
              </li>
              <li class="sidebar-item">
                <router-link
                  to="/app/support"
                  class="sidebar-link"
                  active-class="active"
                  @click="fecharSidebar"
                >
                  <i class="ti ti-headset"></i>
                  <span class="hide-menu">Entrar em contato</span>
                </router-link>
              </li>
            </ul>

            <TourUsuario @iniciar-tour="fecharSidebarAoIniciarTour" />
          </nav>
        </div>

        <div class="sidebar-user">
          <div class="d-flex align-items-center gap-2">
            <div class="avatar-inicial">{{ inicial }}</div>
            <span class="sidebar-user-name">{{ primeiroNome }}</span>
          </div>
          <button
            type="button"
            class="sidebar-logout"
            aria-label="Sair"
            @click="sairConta()"
          >
            <img src="/assets/icons/logout-icon.svg" width="18" height="18" alt="" />
            <span>Sair</span>
          </button>
        </div>
      </aside>

      <!-- MAIN -->
      <div class="body-wrapper">
        <header class="mobile-header d-xl-none">
          <button
            type="button"
            class="mobile-menu-toggle tour-mobile-menu"
            aria-label="Abrir menu"
            @click="toggleSidebarMobile"
          >
            <i class="ti ti-menu-2"></i>
          </button>

          <router-link to="/app" class="mobile-header-logo">
            <img src="/assets/images/logos/logotipo-bg-branco.svg" height="38" alt="WiseCalc" />
          </router-link>

          <div class="mobile-header-user">
            <div class="avatar-inicial">{{ inicial }}</div>
            <span>{{ primeiroNome }}</span>
            <button type="button" class="sidebar-logout" @click="sairConta()">
              <img src="/assets/icons/logout-icon.svg" width="18" height="18" alt="" />
              <span>Sair</span>
            </button>
          </div>
        </header>

        <!-- CONTEÚDO -->
        <div class="card-principal container-fluid" style="max-width: 1400px">
          <div class="card mt-4">
            <div class="card-body" style="min-height: 600px">
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import TourUsuario from '@/components/TourUsuario.vue';
  import { carregarTipoUsuario, clearUsuario, getDeviceId, getSessionId, getUsuario } from '@/utils/authStorage';

  export default {
    name: "AppLayout",

    components: {
      TourUsuario
    },

    data() {
      return {
        primeiroNome: "",
        inicial: "",
        tipoUsuario: null,
        sidebarAberta: false,
        heartbeatId: null
      };
    },

    computed: {
      isAdmin() {
        return this.tipoUsuario === "admin";
      }
    },

    async mounted() {

      // carregar usuário (mantém)
      const usuario = getUsuario();
      if (!usuario) {
        this.$router.replace('/login');
        return;
      }
      this.primeiroNome = usuario.nome.split(" ")[0];
      this.inicial = usuario.nome.trim().charAt(0).toUpperCase();
      this.tipoUsuario = await carregarTipoUsuario();
      this.heartbeatId = window.setInterval(this.validarSessao, 30000);
    },

    methods: {
      // toggleSidebarMobile() {
      //   const wrapper = document.getElementById("main-wrapper");
      //   if (!wrapper) return;

      //   // MOBILE → só mexe no show-sidebar
      //   wrapper.classList.toggle("show-sidebar");
      // },

      toggleSidebarMobile() {
        const wrapper = document.getElementById("main-wrapper");
        if (!wrapper) return;

        this.sidebarAberta = !this.sidebarAberta;
        wrapper.classList.toggle("show-sidebar");

        if (this.sidebarAberta) {
          setTimeout(() => {
            document.addEventListener("click", this.handleClickOutsideSidebar);
          }, 0);
        } else {
          document.removeEventListener("click", this.handleClickOutsideSidebar);
        }
      },

      handleClickOutsideSidebar(event) {
        const sidebar = this.$refs.sidebar;

        if (!sidebar) return;

        if (!sidebar.contains(event.target)) {
          this.fecharSidebar();
        }
      },
    
      async sairConta() {
        const usuario = getUsuario();
        try {
          // keepalive garante o envio da requisição mesmo com a navegação logo em seguida
          await fetch(`${process.env.VUE_APP_BACKEND_URL}/logout`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: usuario?.email, sessionId: getSessionId(), deviceId: getDeviceId() }),
            keepalive: true
          });
        } catch (error) {
          console.error('Não foi possível encerrar a sessão no servidor:', error);
        } finally {
          clearUsuario();
          window.location.href = `${process.env.VUE_APP_FRONTEND_URL}`;
        }
      },

      async validarSessao() {
        const usuario = getUsuario();
        const sessionId = getSessionId();
        if (!usuario || !sessionId) return;

        try {
          const response = await fetch(`${process.env.VUE_APP_BACKEND_URL}/session/heartbeat`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: usuario.email, sessionId, deviceId: getDeviceId() })
          });

          if (response.status === 401) {
            clearUsuario();
            window.location.href = `${process.env.VUE_APP_FRONTEND_URL}/login`;
          }
        } catch (error) {
          console.error('Não foi possível validar a sessão:', error);
        }
      },

      // fecharSidebar() {
      //   const wrapper = document.getElementById("main-wrapper");
      //   if (!wrapper) return;

      //   wrapper.classList.remove("show-sidebar");
      // }

      fecharSidebar() {
        const wrapper = document.getElementById("main-wrapper");
        if (!wrapper) return;

        wrapper.classList.remove("show-sidebar");
        this.sidebarAberta = false;

        document.removeEventListener("click", this.handleClickOutsideSidebar);
      },

      fecharSidebarAoIniciarTour() {
        if (window.innerWidth >= 1200) return;
        this.fecharSidebar();
      },

    },

    beforeUnmount() {
      window.clearInterval(this.heartbeatId);
      document.removeEventListener("click", this.handleClickOutsideSidebar);
    },
  };
  </script>

  <style>
  * {
    font-family: "Manrope", system-ui, sans-serif;
  }

  body,
  .app-header {
    background-color: #edf7ff;
  }

  .avatar-inicial {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #0056ff;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .sidebar-content {
    min-height: 0;
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  .left-sidebar {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .sidebar-nav {
    flex: 1;
  }

  .sidebar-nav ul .sidebar-item .sidebar-link {
    font-size: 14px;
  }

  .sidebar-user {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 16px 18px;
    margin-bottom: 3rem !important;
    border-top: 1px solid #e5eaef;
    background: #fff;
  }

  .sidebar-user > div:first-child {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    flex: 1;
  }

  .sidebar-user-name {
    overflow: hidden;
    font-size: 14px;
    font-weight: 700;
    color: #202c43;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sidebar-user .sidebar-logout {
    margin-left: 12px;
  }

  .mobile-header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    height: 80px;
    padding: 0 24px;
    background-color: #fff;
    border-bottom: 1px solid #e5eaef;
  }

  .mobile-header-logo {
    margin-left: 16px;
  }

  .mobile-header-logo img {
    width: 160px;
    object-fit: contain;
  }

  .mobile-header-user {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
    color: #202c43;
    font-weight: 700;
  }

  .mobile-header-user > span {
    font-size: 14px;
  }

  .mobile-header-user .sidebar-logout {
    margin-left: 12px;
  }

  .sidebar-logout {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    gap: 5px;
    padding: 8px 10px;
    border: 0;
    border-radius: 4px;
    background-color: #fff1f1;
    color: #dc3545;
    font-size: 14px;
    font-weight: 600;
    transition: background-color 0.2s ease, color 0.2s ease;
  }

  .sidebar-logout:hover {
    background-color: #dc3545;
    color: #fff;
  }

  .sidebar-logout:hover img {
    filter: brightness(0) invert(1);
  }

  .mobile-menu-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 0;
    border-radius: 6px;
    background-color: #fff;
    color: #0056ff;
  }

  .mobile-menu-toggle .ti {
    font-size: 24px;
    font-weight: 500;
    -webkit-text-stroke: 0.15px currentColor;
  }

  @media (max-width: 1199px) {
    .sidebar-user {
      display: none;
    }

    .body-wrapper {
      padding-top: 80px;
    }
  }


  </style>
